import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_PROGRAM_V3_URL ?? `${hostConfig.apiBaseUrl}/program-service-ts`;

class ProgramServiceV3 {
  get apiClient() {
    if (!this._apiClient) this._apiClient = createAxiosInstance(baseUrl);
    return this._apiClient;
  }

  async upsertProgramSupplemental({ programId, key, value }) {
    const response = await this.apiClient?.put(
      `/v3/program-supplemental`,
      { programId, key, value },
      { errorContext: "Failed to upsert program supplemental" }
    );
    return response?.data?.result;
  }

  async getProgramMetricConfig(programId, clientId, { cardId, silent } = {}) {
    const response = await this.apiClient?.get(`/v3/program-metric-config/program/${programId}`, {
      params: { clientId, ...(cardId != null ? { cardId } : {}) },
      errorContext: "Failed to load program metrics",
      ...(silent ? { silent: true } : {}),
    });
    return response?.data?.result;
  }

  async getMetrics(programId, clientId) {
    const response = await this.apiClient?.get(`/v3/program/${programId}/metrics`, {
      params: { clientId },
      errorContext: "Failed to load program metric",
      silent: true,
    });
    return response?.data?.result;
  }

  async getProgramEarnings(programId, clientId) {
    const response = await this.apiClient?.get(`/v3/program-earnings/program/${programId}`, {
      params: { clientId },
      errorContext: "Failed to load program earnings",
      silent: true,
    });
    return response?.data?.result;
  }

  async upsertProgramMetricConfig(programId, rows, clientId, cardId) {
    const response = await this.apiClient?.put(
      `/v3/program-metric-config/program/${programId}`,
      { rows },
      { params: { clientId, ...(cardId != null ? { cardId } : {}) }, silent: true }
    );
    return response?.data?.result;
  }

  async getMetricOptions(programId, clientId) {
    const response = await this.apiClient?.get(
      `/v3/program-metric-config/program/${programId}/metric-options`,
      {
        params: { clientId },
        errorContext: "Failed to load metric options",
      }
    );
    return response?.data?.result;
  }

  async getMetricProjections(programId, clientId) {
    const response = await this.apiClient?.get(
      `/v3/program-metric-config/program/${programId}/metric-projections`,
      {
        params: { clientId },
        errorContext: "Failed to load metric projections",
      }
    );
    return response?.data?.result;
  }
}

export default ProgramServiceV3;
